import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { SharedModule } from 'src/app/modules/shared/shared.module';
import { HttpErrorInterceptor } from 'src/app/modules/core/helpers/http-error.interceptor';
import { CpgRoutingModule } from 'src/app/modules/cpg/cpg-routing.module';

import { LoginComponent } from 'src/app/modules/cpg/login/login.component';
import { DashboardComponent } from 'src/app/modules/cpg/dashboard/dashboard.component';
import { CreateCouponComponent } from 'src/app/modules/cpg/coupon/create-coupon/create-coupon.component';
import { CouponListComponent } from 'src/app/modules/cpg/coupon/coupon-list/coupon-list.component';
import { CouponReportComponent } from 'src/app/modules/cpg/reports/coupon-report/coupon-report.component';
import { PaymentsComponent } from 'src/app/modules/cpg/payments/payments.component';

import { PageFiltersComponent } from 'src/app/modules/cpg/components/page-filters/page-filters.component';
import { ChangePasswordComponent } from './change-password/change-password.component';

@NgModule({
  declarations: [
    LoginComponent,
    DashboardComponent,
    CreateCouponComponent,
    CouponListComponent,
    CouponReportComponent,
    PaymentsComponent,
    
    PageFiltersComponent,
          ChangePasswordComponent,
  ],
  imports: [
    CpgRoutingModule,
    CommonModule,
    SharedModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
  ],
  exports: [],
})
export class CpgModule { }
